<main class="fadeIn">
  <div class="container-fluid" #focusedElement>
    <div class="row">
      <div class="col-12">
        <div class="header d-flex justify-content-between">
          <h1><small>&nbsp;</small>Subscriber Rule Configurations</h1>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="filter-body">
          <div class="filter">
            <div class="row justify-content-between">
              <div class="col-10">
                <div class="row" [formGroup]="filterationForm">
                  <div class="col-2" *ngIf="user?.userType == 1 ">
                    <div class="radio-list  form-check-wrap">
                      <div class="form-check form-check-inline"
                        *ngIf="checkPermission('getProvider') && ( subTypeEvm == subTypes.provider|| subTypeEvm == subTypes.both)">
                        <input class="form-check-input" type="radio" id="radio-buttonProvider" name="radio-button3"
                          formControlName="subType" (change)="handleChange($event)" value="provider">
                        <label class="form-check-label" for="radio-buttonProvider">Provider</label>
                      </div>
                      <div *ngIf="checkPermission('getPayer') && ( subTypeEvm == subTypes.payer|| subTypeEvm == subTypes.both)"
                        class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" id="radio-buttonPayer" name="radio-button3"
                          formControlName="subType" value="payer" (change)="handleChange($event)">
                        <label class="form-check-label" for="radio-buttonPayer">Payer</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-3" *ngIf="user?.userType == 1 && filterationForm?.controls?.['subType']?.value == 'provider'">
                    <app-select-dropdown id="providerId" [options]="providerList" label="providerName"
                      [placeholder]="'Linked Provider'" formControlName="providerId"
                      [search]="providerList.length>10?true:false">
                    </app-select-dropdown>

                  </div>
                  <div class="col-3" *ngIf="user?.userType == 1 && filterationForm?.controls?.['subType']?.value == 'payer'">
                    <app-select-dropdown id="payerId" [options]="payerList" label="payerName"
                      [placeholder]="'Linked Payer'" formControlName="payerId"
                      [search]="payerList.length>10?true:false">
                    </app-select-dropdown>

                  </div>
                  <div class="col">
                    <app-datepicker_v2 formControlName="validity" [field]="feild_startDate" [disabled]="isAddPage">
                    </app-datepicker_v2>
                  </div>
                  <div class="col">
                    <input type="text" class="form-control " formControlName="version" id="searchVersion"
                      placeholder="Search by version" appPreventFirstSpace>
                  </div>
                  <div class="col">
                    <input autocomplete="disabled" class="form-check-input" formControlName="inUse" type="checkbox"
                      id="inUse" name="inUse" (change)="isInUseChecked($event)">
                    <label class="form-check-label link" for="inUse">In Use</label>
                  </div>
                  <div class="col-2 d-flex">
                    <button id="btnDrugFilterApply" type="button" (click)="onApply()"
                      class="btn btn-dark-blue">APPLY</button>
                    <a class="reset-btn" (click)="onReset()"><span></span>Reset</a>
                  </div>
                </div>

              </div>
              <div class="col-2"
                *ngIf="checkPermission('addClientRuleConfig') || checkPermission('addProviderRuleConfig') || checkPermission('addPayerRuleConfig')">
                <button id="btnGroupAddNewDrugList" type="button" data-bs-toggle="modal" (click)="configurationAdd()"
                  class="btn btn-primary float-end">
                  ADD New
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="table-container table-responsive">
          <table class="table table-list" *ngIf="ruleConfigList?.length">
            <caption class="d-none">Preferref drug list table body</caption>
            <thead>
              <tr>
                <th scope="col" *ngIf="user?.userType == 1 && (subTypeEvm)">Linked {{listHead}}
                  <span class="sort-order" (click)="sortColumn('SubscriberName')">
                    <a class="{{columnSort['SubscriberName'].sortType}} "></a>
                  </span>
                </th>
                <th scope="col">Validity<span class="sort-order" (click)="sortColumn('activeFrom')"><a
                      class="{{columnSort['activeFrom'].sortType}} "></a></span>
                </th>
                <th scope="col">Version<span class="sort-order" (click)="sortColumn('version')"><a
                      class="{{columnSort['version'].sortType}} "></a></span>
                </th>
                <th scope="col">Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ruleConfig of ruleConfigList">
                <td *ngIf="user?.userType == 1 && ( subTypeEvm )">{{ruleConfig?.SubscriberName || '-'}}</td>
                <td>{{ruleConfig?.activeFrom | dateFormat}} - {{ruleConfig?.expiredOn | dateFormat}}</td>
                <td>
                  {{ruleConfig?.version || ruleConfig?.payerRuleConfigurationVersion || ruleConfig?.providerRuleConfigurationVersion }}
                </td>
                <td>
                  <ul class="actions">
                    <li
                      *ngIf="checkPermission('editRuleConfigVersion')|| checkPermission('editPayerRuleConfigVersion') || checkPermission('editProviderRuleConfigVersion') ">
                      <a id="RuleCNEdit" data-bs-toggle="modal" (click)="configurationEdit(ruleConfig)"
                        class="edit-icon tool-wrap position-relative">
                        <div class="custom-tooltip tooltip-top" role="tooltip">
                          <div class="arrow"></div>
                          <div class="tooltip-inner"> Edit </div>
                        </div>
                      </a>
                    </li>
                    <li
                      *ngIf="checkPermission('viewClientRuleConfigList') || checkPermission('viewProviderRuleConfigList') || checkPermission('viewPayerRuleConfigList')">
                      <a id="RuleCNView" data-bs-toggle="modal" (click)="configurationDetails(ruleConfig)"
                        class="view tool-wrap position-relative">
                        <div class="custom-tooltip tooltip-top" role="tooltip">
                          <div class="arrow"></div>
                          <div class="tooltip-inner"> View </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="no-data with-border" *ngIf="!ruleConfigList?.length">
            <img src="./assets/images/icons/no-data-img.svg" alt="">
            <p>No Results Found</p>

          </div>
        </div>
        <app-navigation *ngIf="!showNavigation" [listLength]="totalCount" [pageNo]="page_no"
          (currentPageDetail)="currentPageDetail($event)">
        </app-navigation>
      </div>
    </div>
  </div>
</main>
<app-rule-configuration-edit *ngIf="showConfigurationEdit" [selectedConfig]="selectedConfig"
  (close)="showConfigurationEdit = false; isAddPage=false;applyFilter()" [isAddPage]="isAddPage">
</app-rule-configuration-edit>
<app-rule-configuration-details *ngIf="showConfigurationDetails" [selectedConfig]="selectedConfig"
  (close)="showConfigurationDetails = false" (editPage)="manageEdit()" (selectedItem)="selectedConfig">
</app-rule-configuration-details>
